import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));



export default function PretArticleDialogContent({onChange, action }) {

    const classes = useStyles();

    const [commande, setCommande] = useState('');
    const [codeArticle, setCodeArticle] = useState('');
    const [commentaire, setCommentaire] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);



    useEffect(() => {

        const getActionData = () => {

            if (!commande || !codeArticle) {
                return null;
            }


            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.NumeroPiece,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Commande client",
                        position: 0,
                        valeurString: commande
                    }, {
                        code: ReclamationActionDetailCodes.CodeArticle,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Article proposé",
                        position: 1,
                        valeurString: codeArticle
                    }]
            };


            if (commentaire) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Commentaire,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Commentaire",
                    position: actionData.details.length,
                    valeurString: commentaire
                });
            }


            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, commande, codeArticle, commentaire]);







    return (
        <DialogContent>
            <TextField className={classes.formControl} value={commande} onChange={e => setCommande(e.target.value)} variant={"filled"} label={"Commande client"}/>
            <TextField className={classes.formControl} value={codeArticle} onChange={e => setCodeArticle(e.target.value)} variant={"filled"} label={"Article proposé"}/>
            <TextField className={classes.formControl} value={commentaire} onChange={e => setCommentaire(e.target.value)} variant={"filled"} label={"Commentaire"} multiline/>
        </DialogContent>
    );

}